var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgGallery(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 7.496l-.7 6.576-.4-5.496a4.324 4.324 0 00-4.3-4h-.296l-18.8 1.288c-.319.022-.634.081-.94.176l.12-1.16A3.224 3.224 0 018.22 2l18.9 1.972A3.2 3.2 0 0130 7.496z",
    fill: "#CEE6F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.136 28.564L6.188 30a3.197 3.197 0 01-3.448-2.96l-.14-1.896a4.316 4.316 0 003.832 2.336h.296l18.8-1.288a4.2 4.2 0 002.548-1.068 3.2 3.2 0 01-2.94 3.44z",
    fill: "#AECCD9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8 8.656l.896 13.013a3.228 3.228 0 01-3.04 3.4L6.4 26.4a3.24 3.24 0 01-3.484-2.956L2 10.425A3.232 3.232 0 015.044 7.02L24.316 5.7A3.228 3.228 0 0127.8 8.656z",
    fill: "#6CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.444 13.405a2.238 2.238 0 002.24-2.236 2.238 2.238 0 00-2.24-2.236 2.238 2.238 0 00-2.24 2.236 2.238 2.238 0 002.24 2.236z",
    fill: "#FFD966"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.372 23.953l.112 1.6L6.4 26.4a3.24 3.24 0 01-3.484-2.956l-.2-2.924 1.244-1.388 1.96-2.196a2.8 2.8 0 013.876-.264l2.248 1.904 6.328 5.376z",
    fill: "#6DD96D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.36 16.8l.336 4.889a3.228 3.228 0 01-3.04 3.4L7.344 26.325l5.144-5.896 4.4-5.044 2.624-2.985a2.496 2.496 0 013.52-.244l3 2.617L28.36 16.8z",
    fill: "#82ED82"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.032 14.76l-9.14.624 2.62-2.984a2.496 2.496 0 013.52-.244l3 2.604zM12.032 18.568l-8.084.556 1.96-2.196a2.8 2.8 0 013.876-.264l2.248 1.904z",
    fill: "#F2FBFF"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h28v28H0z"
  })))));
}
export default SvgGallery;